var _defs, _path, _path2, _path3, _path4, _g, _g2, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSoapDispenserOrange(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 621.96 1431.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1, .cls-2, .cls-3, .cls-4 {\r\n        stroke-miterlimit: 10;\r\n        stroke-width: 3px;\r\n      }\r\n\r\n      .cls-1, .cls-3, .cls-4 {\r\n        stroke: #000;\r\n      }\r\n\r\n      .cls-1, .cls-5 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-6, .cls-2, .cls-4 {\r\n        fill: none;\r\n      }\r\n\r\n      .cls-6, .cls-7, .cls-5 {\r\n        stroke-width: 0px;\r\n      }\r\n\r\n      .cls-8 {\r\n        clip-path: url(#clippath);\r\n      }\r\n\r\n      .cls-2 {\r\n        stroke: #231f20;\r\n      }\r\n\r\n      .cls-7 {\r\n        fill: #ff8a00;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #d1d3d4;\r\n      }\r\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M93.94,117.81c13.67-3.52,27.55-7.14,39.58-14.68,6.08-3.81,11.58-8.57,17.68-12.34,13.99-8.65,30.44-11.75,46.53-14.71,34.77-6.41,69.54-12.81,104.3-19.22,16.8-3.1,33.64-6.2,50.72-7.38,11.29-.78,22.79-.74,33.62-3.93,11.4-3.37,21.54-10.18,32.73-14.19,24.46-8.77,53.53-2.8,74,15.19,24.28,21.34,34.63,55.79,38.31,88.63,3.69,32.83,2.04,66.14,8.4,98.61,6.45,32.9,21.04,64.47,22.17,97.86,1.05,31.06-9.68,60.74-12.05,91.59-6.76,87.67,53.77,176.89,30.98,260.86-12.52,46.14-49.17,80.88-90.74,99.23-41.57,18.35-87.85,22.27-133.39,22.83-51.97.63-104.13-2.84-155.89-10.4-27.17-3.97-55.03-9.36-78.64-24.85-23.61-15.48-42.24-43.34-40.19-72.22,3.33-46.83,56.95-78.58,50.88-125.44-3.9-30.19-30.9-50.32-51.22-72.37-40.55-44.02-59.32-109.42-48.33-168.41,3.68-19.75,10.44-38.68,13.21-58.62,2.69-19.3,1.53-39.08-1.8-58.43-3.3-19.15-11.8-37.8-14.5-56.8-4.68-33.02,43.03-35.49,63.6-40.8Z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M519.95,1311.61h42.36c31.96,0,57.88-25.91,57.88-57.88V59.38c0-31.97-25.92-57.88-57.88-57.88H59.72C27.75,1.5,1.84,27.41,1.84,59.38v1194.35c0,31.97,25.91,57.88,57.88,57.88h51.76"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M619.6,788.79v466.62s-1.35,52.38-56.15,56.65h-43.5v-206.56H111.22v205.68h-56.03s-50.88-2.21-52.91-57.26L1.61,209.94s109.16,359.55,617.99,578.85Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M111.48,1327.91v-222.41h408.47v214.89c0,4.78.18,9.55.47,14.32.75,12.53-.32,47.35-31.25,73.42-17.19,14.49-39.16,22.07-61.65,22.07h-234.21s-41.28.23-67.11-45.3c-9.84-17.34-14.72-37.06-14.72-56.99Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M620.83,789.79S154.3,612.09,1.13,208.67"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 274.48,
    y: 806.22,
    width: 75.52,
    height: 6.02,
    rx: 3.01,
    ry: 3.01
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 257.26,
    y: 818.47,
    width: 105.63,
    height: 12.46,
    rx: 6.23,
    ry: 6.23
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M341.76,830.62v18.54h4.23v10.51h-9.03v4.12l14.79,16.32s19.44-2.11,19.65,10.93l1.64,62.21,18.7.58.85,62.76s-1.23,4.89-8.77,9.68v12.01s-4.37,8.7-13.38,9.61l-9.44,1.13v7.53s.07,5.28-5.7,5.84v43.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M280.26,830.62v18.54h-4.23v10.51h9.03v4.12l-14.79,16.32s-19.44-2.11-19.65,10.93l-1.64,62.21-18.7.58-.85,62.76s1.23,4.89,8.77,9.68v12.01s4.37,8.7,13.38,9.61l9.44,1.13v7.53s-.07,5.28,5.7,5.84v43.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M345.99,812.24s1,4.31,7.71,6.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M279.35,812.24s-1,4.31-7.71,6.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M248.34,952.99s61.53,11.99,125.12,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M269.99,879.81s45.37,11.48,82.6,0"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 284.78,
    y1: 863.52,
    x2: 336.64,
    y2: 863.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 284.3,
    y1: 859.46,
    x2: 337.64,
    y2: 859.46
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M260.48,1049.27s44.52,10.03,100.15-.46"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 266.4,
    y1: 1063.05,
    x2: 355.55,
    y2: 1063.05
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 10.17,
    y: -11.08,
    width: 595.76,
    height: 872.47
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M17.72,561.12c42.99,26.02,91.09,57.06,139.34,43.46,56.89-16.04,87.61-88.58,146.12-96.65,64.67-8.92,113.71,66.26,178.76,71.67,34.1,2.84,67.86-15.08,89.76-41.69,21.9-26.61,33.04-60.92,37.37-95.28,6.44-51.14-1.21-102.89-8.84-153.86-11.46-76.5-22.92-153.01-34.37-229.51-3.71-24.8-7.98-50.91-23.66-70.34-21.56-26.71-58.55-33.69-92.43-37.32C255.92-69.24,56.87-38.19-121.81,40.72c-33.18,14.66-66.16,31.25-92.93,55.92-26.77,24.67-46.98,58.54-48.54,95.16-.97,22.8,5.19,45.2,10.11,67.47,7.16,32.35,11.79,65.28,13.86,98.37,1.06,16.87,1.45,33.78,1.17,50.68-.17,10.33-6.5,36.23-1.25,44.79,9.07,14.8,62.66,20.35,79.85,26.08,29.19,9.73,57.88,21,85.92,33.75,31.34,14.25,61.85,30.33,91.34,48.17Z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M93.94,117.81c13.67-3.52,27.55-7.14,39.58-14.68,6.08-3.81,11.58-8.57,17.68-12.34,13.99-8.65,30.44-11.75,46.53-14.71,34.77-6.41,69.54-12.81,104.3-19.22,16.8-3.1,33.64-6.2,50.72-7.38,11.29-.78,22.79-.74,33.62-3.93,11.4-3.37,21.54-10.18,32.73-14.19,24.46-8.77,53.53-2.8,74,15.19,24.28,21.34,34.63,55.79,38.31,88.63,3.69,32.83,2.04,66.14,8.4,98.61,6.45,32.9,21.04,64.47,22.17,97.86,1.05,31.06-9.68,60.74-12.05,91.59-6.76,87.67,53.77,176.89,30.98,260.86-12.52,46.14-49.17,80.88-90.74,99.23-41.57,18.35-87.85,22.27-133.39,22.83-51.97.63-104.13-2.84-155.89-10.4-27.17-3.97-55.03-9.36-78.64-24.85-23.61-15.48-42.24-43.34-40.19-72.22,3.33-46.83,56.95-78.58,50.88-125.44-3.9-30.19-30.9-50.32-51.22-72.37-40.55-44.02-59.32-109.42-48.33-168.41,3.68-19.75,10.44-38.68,13.21-58.62,2.69-19.3,1.53-39.08-1.8-58.43-3.3-19.15-11.8-37.8-14.5-56.8-4.68-33.02,43.03-35.49,63.6-40.8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoapDispenserOrange);
export default __webpack_public_path__ + "static/media/soap_dispenser_orange.3ef63ad2859e0c6b243b17f3a132cf41.svg";
export { ForwardRef as ReactComponent };